import React from "react";
import "../styles/OpeningHours.css";

function OpeningHours() {

    return (
        <div className="container-fluid py-5 my-5-5 opening-hours-section-background">
            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-6 d-flex align-items-center opening-hours-photo-container">
                        <img src={require("../assets/photos/opening-hours.webp")} className="opening-hours-photo rounded img-hover-zoom img-shadow" />
                    </div>
                        <div className="col-12 col-md-6 text-center text-white">
                            <h3 className="fs-2">Godziny otwarcia restauracji</h3>
                            <p className="fw-bold mt-4 p-0">poniedziałek - czwartek</p>
                            <p className="fw-light">11:00 - 22:00</p>
                            <hr className="divider" />
                            <p className="fw-bold p-0">piątek, sobota</p>
                            <p className="fw-light">11:00 - 24:00</p>
                            <hr className="divider" />
                            <p className="fw-bold p-0">niedziela i dni świąteczne</p>
                            <p className="fw-light">12:00 - 22:00</p>
                            <p className="fw-light mt-5">Śledź nas na <a href="https://www.facebook.com/restauracjasamiswoi/?locale=pl_PL" className="text-decoration-none text-decoration-underline">Facebooku,</a> aby wiedzieć o zmianach godzin otwarcia</p>
                        </div>
                </div>
            </div>
        </div>
    )

}

export default OpeningHours;